/**
 * KAN-1003: общий юридический подвал. ЮKassa проверяет, что соглашение,
 * политика, цены, реквизиты продавца и контакты поддержки постоянно доступны:
 * подвал один на вход,
 * регистрацию, публичные страницы и кабинет ("Баланс", "Биллинг").
 */
import { Link } from 'react-router-dom';
import {
  LEGAL_PATHS,
  SELLER,
  SELLER_REQUISITES,
  SERVICE_NAME,
  SUPPORT_EMAIL,
  SUPPORT_PHONE_DISPLAY,
  SUPPORT_PHONE_TEL,
} from '@/content/legal/support';

const LINK_CLASS = 'text-gray-600 hover:text-blue-600 hover:underline';

const LEGAL_LINKS = [
  { to: LEGAL_PATHS.terms, label: 'Пользовательское соглашение' },
  { to: LEGAL_PATHS.privacy, label: 'Политика конфиденциальности' },
  { to: LEGAL_PATHS.prices, label: 'Цены' },
] as const;

export function LegalFooter({ className = '' }: { className?: string }) {
  return (
    <footer
      data-testid="legal-footer"
      className={`border-t border-gray-200 pt-4 text-sm text-gray-500 ${className}`.trim()}
    >
      <nav aria-label="Документы сервиса" className="flex flex-wrap gap-x-4 gap-y-1">
        {LEGAL_LINKS.map((link) => (
          <Link key={link.to} to={link.to} className={LINK_CLASS}>
            {link.label}
          </Link>
        ))}
      </nav>
      <p className="mt-2 flex flex-wrap gap-x-2 gap-y-1">
        <span>Поддержка:</span>
        <a href={`mailto:${SUPPORT_EMAIL}`} className={LINK_CLASS}>
          {SUPPORT_EMAIL}
        </a>
        <a href={`tel:${SUPPORT_PHONE_TEL}`} className={LINK_CLASS}>
          {SUPPORT_PHONE_DISPLAY}
        </a>
      </p>
      <p className="mt-2 text-xs text-gray-400" data-testid="legal-footer-requisites">
        {SERVICE_NAME}: {SELLER.shortName}, {SELLER_REQUISITES}
      </p>
    </footer>
  );
}
